import { classes, media, stylesheet } from 'typestyle';
import {
  BlackOpacity07,
  BlackOpacity10,
  Blue80,
  Gray170,
  Gray20,
  typeCompact12RegularProperties,
  typeCompact14MediumProperties,
  typeMono12MediumProperties,
  White,
} from '@traceair/tds';
import { BREAKPOINT_SMALL } from '../../../layout/styles';
import { useSelectedMissionsTab } from '../useSelectedMissionsTab';
import { useUiStore } from '../../../../store/uiStore';
import { MissionTab } from '../../../../consts/missionTab';
import { useCompletedMissionCount } from '../tabs/useCompletedMissionCount';

const css = stylesheet({
  container: {
    display: 'flex',
    background: BlackOpacity07,
    borderRadius: 12,
    padding: 2,
    gap: 2,
    ...typeCompact12RegularProperties,
    ...media(
      {
        maxWidth: BREAKPOINT_SMALL,
      },
      {
        flex: '0 0 100%',
        gap: 24,
        marginTop: 12,
        padding: 0,
        borderRadius: 0,
        borderBottom: `1px solid ${Gray20}`,
        background: 'none',
        ...typeCompact14MediumProperties,
      },
    ),
  },
  tab: {
    padding: '11px 12px',
    border: `1px solid transparent`,
    borderRadius: 10,
    color: Gray170,
    textDecoration: 'none',
    ...media(
      {
        maxWidth: BREAKPOINT_SMALL,
      },
      {
        padding: '4px 0 8px',
        marginBottom: -1,
        borderRadius: 0,
      },
    ),
  },
  tabActive: {
    $nest: {
      '&&': {
        border: `1px solid ${Blue80}`,
        background: White,
        ...media(
          {
            maxWidth: BREAKPOINT_SMALL,
          },
          {
            border: 'none',
            borderBottom: `2px solid ${Blue80}`,
          },
        ),
      },
    },
  },
  counter: {
    padding: '1px 6px',
    marginLeft: 4,
    borderRadius: 12,
    background: White,
    border: `1px solid ${BlackOpacity10}`,
    ...typeMono12MediumProperties,
    ...media(
      {
        maxWidth: BREAKPOINT_SMALL,
      },
      {},
    ),
  },
});

export const MissionNav = () => {
  const { setSelectedMissionsTab } = useUiStore();
  const selectedMissionsTab = useSelectedMissionsTab();
  const completedMissionCount = useCompletedMissionCount();

  return (
    <nav className={css.container} data-intercom-target="MissionNav">
      <a
        className={classes(css.tab, selectedMissionsTab === MissionTab.Schedules && css.tabActive)}
        href="#"
        onClick={() => setSelectedMissionsTab(MissionTab.Schedules)}
        data-intercom-target="MissionNavScheduled"
      >
        Scheduled
      </a>

      <a
        className={classes(css.tab, selectedMissionsTab === MissionTab.Uploaded && css.tabActive)}
        href="#"
        onClick={() => setSelectedMissionsTab(MissionTab.Uploaded)}
        data-intercom-target="MissionNavUploaded"
      >
        Uploaded
        <span className={css.counter}>{completedMissionCount}</span>
      </a>

      <a
        className={classes(css.tab, selectedMissionsTab === MissionTab.AllProjects && css.tabActive)}
        href="#"
        onClick={() => setSelectedMissionsTab(MissionTab.AllProjects)}
        data-intercom-target="MissionNavAllProjects"
      >
        All projects
      </a>
    </nav>
  );
};
